import { render } from "./Errors.vue?vue&type=template&id=49e008a7&scoped=true"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"

import "./Errors.vue?vue&type=style&index=0&id=49e008a7&scoped=true&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e008a7"]])

export default __exports__